import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "../../utils/supabaseClient";
import "../../styles/AdminOrders.css";

export default function AdminOrderDetail() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadOrder();    // loadOrder() in the other file
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  async function loadOrder() {
    const { data: orderData } = await supabase
      .from("orders")
      .select("*")
      .eq("id", id)
      .single();

    const { data: itemsData } = await supabase
      .from("order_items")
      .select("*, products(name, image_url)")
      .eq("order_id", id);

    setOrder(orderData);
    setItems(itemsData);
    setLoading(false);
  }

  async function updateStatus(newStatus) {
    await supabase
      .from("orders")
      .update({ status: newStatus })
      .eq("id", id);

    setOrder((prev) => ({ ...prev, status: newStatus }));
  }

  if (loading) return <p>Loading order...</p>;

  return (
    <div className="page admin-order-detail">
      <h2>Order Details</h2>

      <p><strong>Order ID:</strong> {order.id}</p>
      <p><strong>Email:</strong> {order.email}</p>
      <p><strong>Total:</strong> £{order.total.toFixed(2)}</p>
      <p><strong>Status:</strong> {order.status}</p>

      <div className="status-buttons">
        <button onClick={() => updateStatus("pending")}>Pending</button>
        <button onClick={() => updateStatus("processing")}>Processing</button>
        <button onClick={() => updateStatus("shipped")}>Shipped</button>
        <button onClick={() => updateStatus("delivered")}>Delivered</button>
      </div>

      <h3>Items</h3>

      <table className="admin-table">
        <thead>
          <tr>
            <th>Product</th>
            <th>Qty</th>
            <th>Price (£)</th>
          </tr>
        </thead>

        <tbody>
          {items.map((item) => (
            <tr key={item.id}>
              <td>{item.products?.name}</td>
              <td>{item.quantity}</td>
              <td>{item.price.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}